// Measurement.js

import { isEnumOptionGroup, normalizeEnumOptionValues, normalizeEnumOptions } from 'utilities/EnumOptions';

export const normalizeMeasurementUnitValue = (value) => String(value ?? '').trim();

export const normalizeMeasurementOptions = (options) => (
  normalizeEnumOptions(options)
    .filter((option) => !isEnumOptionGroup(option))
    .map((option) => ({
      id: option.id,
      translations: option.translations,
      value: option.value,
    }))
);

export const normalizeMeasurementDefaultUnit = (defaultUnit, options) => {
  const normalizedDefault = normalizeMeasurementUnitValue(defaultUnit);
  const optionValues = normalizeEnumOptionValues(options);

  if (normalizedDefault && optionValues.includes(normalizedDefault)) {
    return normalizedDefault;
  }

  return optionValues[0] || '';
};

export const normalizeMeasurementValueForInput = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {
      unit: '',
      value: '',
    };
  }

  const rawValue = value.value;

  return {
    unit: normalizeMeasurementUnitValue(value.unit),
    value: rawValue === undefined || rawValue === null ? '' : String(rawValue).trim(),
  };
};

export const normalizeMeasurementValueForStorage = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }

  const rawValue = typeof value.value === 'string' ? value.value.trim() : value.value;
  const unit = normalizeMeasurementUnitValue(value.unit);

  if (rawValue === '' || rawValue === undefined || rawValue === null) {
    return null;
  }

  const numericValue = Number(rawValue);
  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return {
    unit,
    value: numericValue,
  };
};

export const isMeasurementValueEmpty = (value) => !normalizeMeasurementValueForStorage(value);

export const formatMeasurementValue = (value) => {
  const normalized = normalizeMeasurementValueForStorage(value);
  if (!normalized) return '';

  return normalized.unit
    ? `${normalized.value} ${normalized.unit}`
    : String(normalized.value);
};